import { Link } from "react-router-dom";

const NavElement = ({title, path='~', subtle=false}) => {
    const link = path !== '~' ? path : title;
    const url = "/" + link;
    const className = subtle
        ? "pretty-link nav-element nav-link nav-link-subtle"
        : "pretty-link nav-element nav-link";

    return <Link to={url} className={className}>
        {title}
    </Link>;
};

export default NavElement;